import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import FileField from '../../../../components/FileField';
import './styles.less';

export const OrderImportFormView = ({ onDownloadTemplate }) => (
	<Grid className="order-import-form">
		<Grid.Row columns={3} className="order-import-form__row">
			<Grid.Column width={5} className="order-import-form__label">
				Скачать шаблон
			</Grid.Column>
			<Grid.Column width={1}>
				<button
					type="button"
					aria-label="Скачать шаблон"
					className="order-import-form-download-button"
					onClick={onDownloadTemplate}
				/>
			</Grid.Column>
			<Grid.Column width={8}>
				<div className="order-import-form__instructions">
					<p>1. Скачайте шаблон</p>
					<p>2. Заполните шаблон данными</p>
					<p>3. Загрузите шаблон в систему</p>
				</div>
			</Grid.Column>
		</Grid.Row>

		<Grid.Row columns={3} className="order-import-form__row">
			<Grid.Column width={5} className="order-import-form__label">
				Загрузить шаблон
			</Grid.Column>
			<Grid.Column width={10}>
				<Field name="file" component={FileField} />
			</Grid.Column>
		</Grid.Row>
	</Grid>
);

OrderImportFormView.propTypes = {
	onDownloadTemplate: PropTypes.func.isRequired,
};
